
import { useLocation } from "react-router-dom";
import useErrorHandler from "../../../hook/useErrorHandler";
import useUserAuthCore from "./useUserAuthCore";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { IRootState } from "../../../redux/rootReducer";



/**
 * Manage the user data, sessions and authentication.
 * @returns 
 */
function useUserAuth() {
    const {handleNetworkError, handleInternError } = useErrorHandler()
  
    const location : string = useLocation().search;
    const queryClient = useQueryClient();

 

    const {authenticateUserWithToken,token: oldToken,...otherFunctions} = useUserAuthCore(handleNetworkError,handleInternError)
    /**
     *
     * Autentication with url Token
     */
    const authenticateByURL = async () => {
        let  token  = new URLSearchParams(location).get('t');
        if(token){
            queryClient.invalidateQueries()
            queryClient.clear()
         
            authenticateUserWithToken(token);
   
        }
    }
  

    return {
        authenticateUserWithToken,
        ...otherFunctions,
        /**
         * Autentication with url Token
         */
        authenticateByURL,
        /**
         * specifies if the user is a comptable
         */
        isComptable: useSelector((state: IRootState) => state.userAuth.isComptable),
        /**
         * specifies if the user is a superviseur technique
         */
        isSuperviseurTechnique: useSelector((state: IRootState) => state.userAuth.isSuperviseurTechnique),
    }
}

export default useUserAuth
